import esIcon from '@assets/es_ES.png';

const SpFlag = () => {
  return (
    <img src={esIcon} alt={'sp'} style={{'height': '15px', 'padding': '5px'}} />
  )
}

export default SpFlag;